package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class ColumnsFilter(
    val columnName: String,
    val values: List<String>
)